// extracted by mini-css-extract-plugin
module.exports = {"header":"_62591af7","heading":"_e810af80","companyInfo":"_a63039a1","ratingContainer":"_94cba8c8"};